export enum IpoType {
    REAL,
    DRAFT
}
